module.exports = __webpack_public_path__ + "media/public/img/walks-logo-db3252ac29742db2ddc8e535cfdf8616.png";